<script>
import store from '@state/store'
import { debounce } from 'debounce'
import { authComputed } from '@state/helpers'
import AdminTable from '@components/admin-table.vue'
import {
  USERS_TABLE_FIELDS,
  GROUPS_TABLE_FIELDS,
} from '@adminCompanies/constant'

export default {
  components: {
    AdminTable,
  },

  props: {
    tableType: { type: String, required: true },
    companyId: { type: [String, Number], required: true },
    noNewBtn: { type: Boolean, required: false, default: false },
    eventId: { type: Number, default: null },
    noEditBtn: { type: Boolean, required: false, default: false },
  },

  data() {
    return {
      page: 1,
      perPage: 10,
      lists: [],
      total: 0,
      filter: {},
      sort: {},
      loaded: false,
    }
  },

  computed: {
    ...authComputed,
    computedTableType() {
      if (this.tableType === 'ADMIN_USERS') {
        return 'USERS'
      }
      return this.tableType
    },
    tableFields() {
      if (
        ['USERS', 'LEADERS', 'EVENT_ADMINS'].includes(this.computedTableType)
      ) {
        return USERS_TABLE_FIELDS
      } else if (this.computedTableType === 'GROUPS') {
        return GROUPS_TABLE_FIELDS
      }
      return []
    },
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.loaded = false
      this.lists = []
      if (
        ['USERS', 'LEADERS', 'EVENT_ADMINS'].includes(this.computedTableType)
      ) {
        this.fetchUsers()
      } else if (this.computedTableType === 'GROUPS') {
        this.fetchGroups()
      }
    },
    fetchUsers() {
      let params = {
        companyId: this.companyId,
        filter: this.filter,
        page: this.page,
        per_page: this.perPage,
        sort: this.sort,
      }
      if (this.tableType === 'EVENT_ADMINS') {
        params = Object.assign(params, { eventAdminsOf: this.companyId })
      }
      store
        .dispatch('adminUsers/fetchLists', params)
        .then((result) => {
          this.lists = result.data
          this.total = result.total
        })
        .catch((err) => {
          alert(err.message || 'Something went wrong.')
        })
        .finally(() => {
          this.loaded = true
        })
    },
    fetchGroups() {
      const params = {
        companyId: this.companyId,
        filter: this.filter,
        page: this.page,
        per_page: this.perPage,
        sort: this.sort,
      }

      store
        .dispatch('adminGroups/fetchLists', params)
        .then((result) => {
          this.lists = result.data
          this.total = result.total
        })
        .catch((err) => {
          alert(err.message || 'Something went wrong.')
        })
        .finally(() => {
          this.loaded = true
        })
    },
    setPage({ page, perPage }) {
      this.page = page
      this.perPage = perPage
      this.fetchData()
    },
    setFilterParams: debounce(async function setFilterParams(params) {
      this.filter = { ...params }
      this.fetchData()
    }, 500),
    setSortParams(params) {
      this.sort = { ...params }
      this.fetchData()
    },
    goAddItem() {
      let routerName = ''
      if (this.computedTableType === 'USERS') {
        routerName = 'adminUsersAdd'
      } else if (this.computedTableType === 'GROUPS') {
        routerName = 'adminGroupsAdd'
      }
      this.$router.push({
        name: routerName,
        params: { companyId: this.companyId },
      })
    },
    goEditItem(item) {
      if (this.computedTableType === 'GROUPS') {
        const name = 'adminGroupsEdit'
        const params = {
          companyId: this.companyId,
          groupId: item.id,
          item,
        }
        this.$router.push({ name, params })
      }
    },
    deleteItem(id) {
      let params = {}
      let action = ''
      if (this.tableType === 'EVENT_ADMINS') {
        action = 'adminUsers/removeEventAdminOfCompany'
        params = { companyId: this.companyId, userId: id }
      }
      store
        .dispatch(action, params)
        .then((result) => {
          if (result === true) {
            this.fetchData()
          }
        })
        .catch((err) => {
          alert(err.message || 'Something went wrong.')
        })
    },
  },
}
</script>

<template>
  <AdminTable
    :table-type="computedTableType"
    :table-fields="tableFields"
    :no-new-btn="noNewBtn"
    :no-edit-btn="noEditBtn"
    :total-num="total"
    :list-data="lists"
    :data-loaded="loaded"
    :cur-page="page"
    :per-page="perPage"
    @table-add-item="goAddItem"
    @table-set-sort-params="setSortParams"
    @table-set-filter-params="setFilterParams"
    @table-go-edit-item="goEditItem"
    @table-delete-item="deleteItem"
    @table-set-page="setPage"
  />
</template>
